import { useEffect, useState } from 'react';
import {
    TableContainer,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Input,
    Select,
    TableCaption,
    Flex,
    Text,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';

export default function CustomTable({ editTable, productDetail, handleChange }) {
    const { variantTableData } = useSelector((state) => state.storeReducer);
    const [tableDataState, setTableDataState] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!variantTableData) return;
        const transformVariantTableData = () => {
            let result = [];
            if (!variantTableData?.Color?.length) {
                setError('Please choose a color');
                setTableDataState([]);
                return [];
            }
            variantTableData?.Size?.forEach((size) => {
                result.push({
                    id: size,
                    items: `${size}, ${variantTableData?.Color?.[0]}`,
                    status: 0,
                    price: 0,
                    stock: 1,
                });
            });
            setError('');
            return result;
        };
        setTableDataState(transformVariantTableData);
    }, [variantTableData, variantTableData?.Color, variantTableData?.Size]);

    return (
        <TableContainer overflowX="auto">
            <Table
                fontSize={{
                    base: '.7rem',
                    sm: '.8rem',
                    md: '.8rem',
                    lg: '.9rem',
                }}
                width="full"
                size="sm"
                className="table-tiny"
                position="relative">
                {error ? (
                    <TableCaption fontSize="md" color="red.500">
                        {error}
                    </TableCaption>
                ) : null}
                <Thead>
                    <Tr>
                        <Th>Options</Th>
                        <Th>Price</Th>
                        <Th>Status</Th>
                        <Th>Stock</Th>
                    </Tr>
                </Thead>
                {tableDataState.length ? (
                    <Tbody>
                        {tableDataState.map(({ id, items, price, status, stock }) => (
                            <Tr key={id}>
                                <Td w="30%">{items}</Td>
                                <Td w="25%">
                                    {editTable ? (
                                        <Input defaultValue={price} />
                                    ) : (
                                        <WalletHistoryPrice price={price} />
                                    )}
                                </Td>
                                <Td>
                                    {editTable ? (
                                        <Select>
                                            <option value={0}>Out of stock</option>
                                            <option value={1}>In stock</option>
                                        </Select>
                                    ) : status ? (
                                        'Out of stock'
                                    ) : (
                                        'In stock'
                                    )}
                                </Td>
                                <Td w="15%">
                                    {editTable ? <Input defaultValue={stock} /> : stock}
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                ) : (
                    <Flex position="relative" py="4" left="36" justifyContent="center">
                        <Text textAlign="center">Select product size and color</Text>
                    </Flex>
                )}
            </Table>
        </TableContainer>
    );
}
